"use client";

import CarouselSection from "@/components/CarouselSection";
import { useTranslations } from "next-intl";

export default function CountryBlogsClient({ blogPosts, formattedCountry }) {
  const t = useTranslations("flight");
  const title = formattedCountry
    ? t("countryBlogTitle", { country: formattedCountry })
    : t("blogPosts");

  return (
    <CarouselSection
      title={title}
      description={t("blogDescription")}
      linkText={t("allView")}
      href="/blog/"
      preserveTrailingSlash={true}
      items={blogPosts}
      componentType="BlogCard"
      componentProps={{}}
    />
  );
}
